import { Component } from '@angular/core';

import { NotificationService } from 'app/core/services/notification.service';
import { ConfigService } from 'app/core/services/config.service';
import { CreditService } from './credit.service';
import { Router, ActivatedRoute } from '@angular/router';
@Component({
  selector: 'itpx-credit',
  templateUrl: './credit.component.html',
  styleUrls: ['./credit.component.css']
})
export class CreditComponent {

    private url: string;
    private buyerId: string;
    private detailsRoute: string = '/organization/credit/{{key}}/details';
    private fields: Array<any> = [
        {
            title: 'Date',
            name: 'createdAt',
            config: {
                type: 'date'
            }
        }, {
            title: 'Username',
            name: 'userName',
            config: {
                type: 'link',
                route: this.detailsRoute,
                key: 'id'
            }
        }, {
            title: 'Status',
            name: 'status.configValue'
        }, {
            title: 'Decision',
            name: 'creditDecision.decision.configValue'
        }
    ];

    constructor( 
        private configService: ConfigService,
        private service: CreditService,
        private router: Router
    ) {
        this.url = this.configService.get('server').url + this.configService.get('endpoints').agora.credit.list.api;
    }

    ngOnInit() {
        
    }

    private checkFinanceUser() {
        this.service.getDetails()
            .flatMap(
                body => this.service.checkFinanceUser(body.data.accountId)
            ).subscribe(
                body => {
                    if(body.data) {
                        this.router.navigate(['/organization/credit/info']);
                    } else {
                        this.router.navigate(['/organization/credit/error']);
                    }
                }
            )
    }

}



// WEBPACK FOOTER //
// ./src/app/organization/components/credit/credit.component.ts